@if (article) {
  <div class="article-link">
    <div class="layout-column snippet-content">
      <a [href]="'./'+article.category.slug+'/'+article.slug" class="image spacer-bottom-8">
        <img [src]="article.heroImageUrl" [alt]="article.title" width="100%" height="100%">
      </a>
      <div class="inner-content">
        <a [href]="'./'+article.category.slug+'/'+article.slug" class="line-clamp2">
          @if (size === 'h2') {
            <h2 [innerHTML]="article.title" [title]="article.title"></h2>
          } @else {
            <h3 [innerHTML]="article.title" [title]="article.title"></h3>
          }
        </a>
        @if (article.hashes.length) {
          <div class="tags layout-row flex-wrap spacer-vr-8">
            @for (item of article.hashes; track item) {
              <a [routerLink]="['/search-results', 'terms', item.tag]" (click)="hashClick(item.hash, 'article snippet')"
              class="small txt-navy-light spacer-right-8">{{item.hash}}</a>
            }
          </div>
        }
        <div class="layout-row align-middle spacer-vr-8 small">
          <span class="category-icon small-icon spacer-right-8">
            <img [src]="article.category.marker" [alt]="article.category.slug" width="16px" height="16px">
          </span>
          <a class="txt-nowrap" [href]="'./'+article.category.slug">{{article.category.name}}</a>
          <span class="align-middle info spacer-left-16 text-right txt-navy-light">{{article.publishDate}} ● {{article.readTime}}</span>
        </div>
      </div>
    </div>
  </div>
}
